module.exports = __webpack_public_path__ + "img/publish.49c0e201.png";